import React, { useState } from 'react';
import { RemoveRedEye } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Button,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Tooltip,
    Typography,
    Chip,
} from '@mui/material';
import { colors } from '../../assets/utils/constants';
import CustomDialog from '../Dialogs/CustomDialog';
import IndividualApplicantDetails from '../../pages/jobs/components/IndividualApplicantDetails';

const IndividualJobApplicantWidget = ({ applicant }) => {
    // ############### Comp State ##################
    const [openDialog, setOpenDialogy] = useState(false);

    // ############### FUNC ##################
    // -> Dialogy closer
    const handleDialogOpen = (actionType) => {
        setOpenDialogy(true);
    };

    // -> Dialogy closer
    const handleDialogClose = () => {
        setOpenDialogy(false);
    };

    return (
        <>
            {/* ############# Dialog ################ */}
            <CustomDialog
                head={'Job application details'}
                openDialog={openDialog}
                customWidth={'md'}
                handleDialogClose={handleDialogClose}
            >
                <IndividualApplicantDetails
                    applicant={applicant}
                    handleDialogClose={handleDialogClose}
                />
            </CustomDialog>

            <ListItem
                alignItems="flex-start"
                secondaryAction={
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Chip
                            label={applicant.type}
                            size="small"
                            color="secondary"
                            sx={{
                                fontSize: 12,
                                fontWeight: 'bold',
                                opacity: 0.8,
                                px: 1,
                                float: 'right',
                                mb: 1,
                            }}
                        />
                        <Tooltip title="Applicant details" arrow>
                            <Button
                                sx={{
                                    bgcolor: colors.bgColor3,
                                }}
                                onClick={() => {
                                    handleDialogOpen();
                                }}
                            >
                                <RemoveRedEye
                                    color="info"
                                    sx={{ fontSize: 20 }}
                                />
                            </Button>
                        </Tooltip>
                    </Box>
                }
                sx={{
                    'transition': '.3s all ease-in-out',
                    'background': `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                    'position': 'relative',
                    'mb': 2,
                    'borderRadius': 2,
                    'transition': '.3s all ease-in-out',
                    'border': `1px solid ${colors.bgColor3}`,
                    ':hover': {
                        transition: '.3s all ease-in-out',
                        border: `1px solid ${colors.bgColor5}`,
                    },
                }}
            >
                <ListItemAvatar>
                    <Avatar
                        alt="Remy Sharp"
                        src={applicant.profile_picture}
                        sx={{
                            height: 70,
                            width: 70,
                            mt: -0.5,
                            mr: 1.5,
                            border: `3px solid ${colors.bgColor5}`,
                            background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor5})`,
                            img: {
                                p: 0.2,
                                borderRadius: 50,
                                objectFit: 'cover',
                            },
                        }}
                    />
                </ListItemAvatar>
                <ListItemText
                    disableTypography
                    primary={
                        <Typography
                            sx={{
                                fontSize: 15,
                                fontWeight: 'bold',
                            }}
                        >
                            {`${applicant.first_name} ${applicant?.middle_name} ${applicant.last_name}`}
                        </Typography>
                    }
                    secondary={
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: colors.info,
                                    fontWeight: 'bold',
                                }}
                                component="span"
                            >
                                {`${applicant?.region}, ${applicant?.district}`}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: colors.warning,
                                    fontWeight: 'bold',
                                    opacity: 0.8,
                                }}
                                component="span"
                            >
                                {applicant.phone_number}
                            </Typography>
                        </Box>
                    }
                />
            </ListItem>
        </>
    );
};

export default IndividualJobApplicantWidget;
